import { jsx as _jsx } from "react/jsx-runtime";
import { FieldSelect } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { useSchedules } from 'components/settings/components/sections/openingHours/utils/useSchedules';
export function ScheduleSelect({ label = 'Schedule', error, onChange, value, }) {
    const { currentPageSchedules, hasNextPage, hasPreviousPage, nextPage, previousPage, } = useSchedules();
    const schedules = currentPageSchedules.map(({ id, name }) => ({
        id,
        name,
    }));
    const handleNextPage = useCallback(() => {
        return Promise.resolve(nextPage());
    }, [nextPage]);
    const handlePreviousPage = useCallback(() => {
        return Promise.resolve(previousPage());
    }, [previousPage]);
    return (_jsx(FieldSelect, { clearable: true, emptyMessage: "Select a schedule", placeholder: "Select a schedule", label: label, meta: { error }, input: {
            name: 'schedule',
            value,
            onChange,
        }, items: schedules, pagination: {
            nextEnable: hasNextPage,
            previousEnable: hasPreviousPage,
            onNext: handleNextPage,
            onPrevious: handlePreviousPage,
        } }));
}
